import { getRaw, postRaw } from 'services/api';

export const FACEBOOK_INTEGRATIONS_URL = '/integrations/facebookIntegration.json';

/**
 * getFacebookIntegrations
 * gets a JSON list of the Facebook integrations
 * @return { Object[] } Object containing a list of Facebook integrations
 */
export function getFacebookIntegrations() {
  return getRaw(FACEBOOK_INTEGRATIONS_URL);
}

export const FACEBOOK_INTEGRATIONS_CREATE_URL = '/integrations/addFacebookIntegration';
/**
 * createFacebookIntegration
 * creates a new ad account
 * @return {}
 */
export function createFacebookIntegration(formData) {
  return postRaw(FACEBOOK_INTEGRATIONS_CREATE_URL, formData);
}

export const FACEBOOK_INTEGRATIONS_DELETE_URL = '/integrations/deleteFacebookIntegration';
/**
 * deleteFacebookIntegration
 * deletes an ad account
 * @return {}
 */
export function deleteFacebookIntegration(formData) {
  return postRaw(FACEBOOK_INTEGRATIONS_DELETE_URL, formData);
}
